import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import KNB from '@dp/knb';
import Geo from 'drip/geo';
import debounce from 'lodash/debounce';
import Url from 'drip/utils/url';
import { isNativeSearch, myNatvieSearch, mtNatvieSearch, dpNatvieSearch } from "@/utils/";
export default {
  name: 'search-bar',
  data: function data() {
    return {
      showCity: true,
      cityName: ''
    };
  },
  computed: {
    isMaoyanI: function isMaoyanI() {
      return ['qqwallet', 'maoyan_i', 'cmb_app', 'shenzhen_icbc'].includes(Drip.constant.uaInfo.appName);
    }
  },
  mounted: function mounted() {
    var _Drip$constant$cityNa = Drip.constant.cityName,
      cityName = _Drip$constant$cityNa === void 0 ? '' : _Drip$constant$cityNa;
    this.cityName = cityName;
    // 猫眼app中不展示定位
    this.showCity = Drip.constant.uaInfo.appName !== 'maoyan';
  },
  methods: {
    handleCityClick: function handleCityClick() {
      var _this = this;
      if (this.isMaoyanI && Drip.UA.IS_WXAPP_MEITUAN) {
        this.$router.push('/cities');
      } else if (this.isMaoyanI) {
        this.go('/cities');
      } else {
        KNB.pickCity({
          type: 0,
          // 默认值0:国内城市, 1: 国际城市;
          needResult: 0,
          // 默认值 0：选择且切换城市，1：支持选择城市但不切换 App 城市
          success: function success(result) {
            var cityName = result.cityName,
              cityId = result.cityId;
            if (!cityId) return;
            _this.cityName = cityName;
            Geo.setCity({
              cityId: cityId,
              cityName: cityName
            });
          }
        });
      }
      window.seedAction({
        bid: 'b_movie_cwyw3css_mc'
      });
    },
    debounceHandleSearchClick: debounce(function () {
      window.seedAction({
        bid: 'b_movie_twpdo6ou_mc',
        needTag: true
      });
      var sellChannel = Drip.constant.appType;
      if (isNativeSearch) {
        var IS_ANDROID = Drip.constant.uaInfo.osName === 'android';
        var mapUrlAddr = '';
        if (myNatvieSearch) {
          mapUrlAddr = IS_ANDROID ? 'maoyan://maoyan.com/vertical/search?searchType=6' : 'maoyan://maoyan.com/searchhomepage?from=3';
        }
        if (mtNatvieSearch) {
          mapUrlAddr = 'imeituan://www.meituan.com/mrn?mrn_biz=movie&mrn_entry=moviechannel-searchhome&mrn_component=moviechannel-searchhome&searchPageType=show';
        }
        if (dpNatvieSearch) {
          mapUrlAddr = 'dianping://mrn?mrn_biz=movie&mrn_entry=moviechannel-searchhome&mrn_component=moviechannel-searchhome&searchPageType=show';
        }
        var a = document.createElement('a');
        a.href = mapUrlAddr;
        a.click();
      }
      //  美大猫微M站 指向新搜索，微信小程序原生，单独处理
      else if ([1, 2, 3, 5, 13, 37].includes(sellChannel)) {
        var url = Url.getUrl('/myshowfe/trade/SearchByIndex', {
          _blank: true
        });
        Drip.redirect(url);
      } else {
        this.go('/search', {
          _blank: true
        });
      }
    }, 300)
  }
};